import { BLANK_CANVAS_PRESETS } from '../utils/canvasPresets'

/** כפתורי מידות קנבס לדף ריק — משתמש ב־welcome-blank-sizes / welcome-size-btn מ־App.css */
export function CanvasSizePresetsRow({ lang = 'he', selectedW, selectedH, onPick, className }) {
  const aria = lang === 'en' ? 'Canvas size (pixels)' : 'גודל קנבס (פיקסלים)'
  return (
    <div className={`welcome-blank-sizes ${className || ''}`.trim()} role="group" aria-label={aria}>
      {BLANK_CANVAS_PRESETS.map((p) => {
        const label = lang === 'en' ? p.labelEn : p.labelHe
        const selected = selectedW === p.w && selectedH === p.h
        return (
          <button
            key={`${p.w}x${p.h}`}
            type="button"
            className={`welcome-size-btn${selected ? ' selected' : ''}`}
            onClick={() => onPick(p.w, p.h)}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
